import React from "react";
import { motion } from "framer-motion";

export default function EzrahAvenue() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center"
        style={{ backgroundImage: "url('/ezrahavenue.jpg')" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <motion.div
          className="relative z-10 text-center text-white px-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4">
            Ezrah
          </h1>
          <p className="text-lg max-w-2xl mx-auto">
            A collection of modern chalets designed for luxury, comfort, and seamless harmony with Aspen’s natural beauty.
          </p>
        </motion.div>
      </section>

      {/* Overview */}
      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12">
        <div>
          <h2 className="text-2xl font-bold mb-4">Overview</h2>
          <p className="text-gray-700 leading-relaxed">
            Ezrah blends elegance with nature. Featuring contemporary chalets with panoramic views, spacious interiors, and sustainable design elements, this development sets a new benchmark for luxury living in Aspen Hills.
          </p>
          <ul className="mt-6 space-y-2 text-gray-600">
            <li><b>Property Type:</b>  Chalets</li>
            <li><b>Location:</b> Ashongman Food Yard Curve</li>
            <li><b>Status:</b> Work In Progress</li>
            <li><b>Price:</b> USD 450,000</li>
          </ul>
        </div>
        <div className="bg-gray-100 rounded-lg shadow-md p-6">
          <h3 className="text-lg font-semibold mb-3">Key Features</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>4 bedrooms fully furnished or unfurnished</li>
            <li>6 washrooms</li>
            <li>1 family area</li>
            <li>Walk-in closet</li>
            <li>CCTV surveillance</li>
            <li>Modern kitchen with premium appliances</li>
            <li>Private terraces with scenic views</li>            
            <li>Modern architectural design</li>
            <li>Open-plan living and dining areas</li>
            <li>Private terraces with scenic views</li>
            <li>Energy-efficient systems</li>
            <li>Smart home technology</li>
            <li>Secure gated home</li>
            <li>Ample parking space</li>
            <li>Proximity to key amenities and transport links</li>
          </ul>
        </div>
      </div>

      {/* Gallery */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-2xl font-bold mb-6">Gallery</h2>
        <div className="grid md:grid-cols-3 gap-6">
          <img src="/ezrahavenue.jpg" alt="Ezrah Avenue 1" className="rounded-lg shadow-md" />
          <img src="/ezrahavenue.jpg" alt="Ezrah Avenue 2" className="rounded-lg shadow-md" />
          <img src="/ezrahavenue.jpg" alt="Ezrah Avenue 3" className="rounded-lg shadow-md" />
          <img src="/ezrah3.jpeg" alt="Ezrah Avenue 7" className="rounded-lg shadow-md" />
          <img src="/ezrah4.jpeg" alt="Ezrah Avenue 8" className="rounded-lg shadow-md" />
          <img src="/ezrah5.jpeg" alt="Ezrah Avenue 9" className="rounded-lg shadow-md" />
          <img src="/ezrah6.jpeg" alt="Ezrah Avenue 10" className="rounded-lg shadow-md" />
          <img src="/ezrah7.jpeg" alt="Ezrah Avenue 11" className="rounded-lg shadow-md" />
          <img src="/ezrah8.jpeg" alt="Ezrah Avenue 12" className="rounded-lg shadow-md" />
          <img src="/ezrah9.jpeg" alt="Ezrah Avenue 13" className="rounded-lg shadow-md" />
          <img src="/ezrah10.jpeg" alt="Ezrah Avenue 14" className="rounded-lg shadow-md" />
          <img src="/ezrah11.jpeg" alt="Ezrah Avenue 15" className="rounded-lg shadow-md" />
          <img src="/ezrah12.jpeg" alt="Ezrah Avenue 16" className="rounded-lg shadow-md" />
          <img src="/ezrah13.jpeg" alt="Ezrah Avenue 17" className="rounded-lg shadow-md" />
          <img src="/ezrah14.jpeg" alt="Ezrah Avenue 18" className="rounded-lg shadow-md" />
          <img src="/ezrah15.jpeg" alt="Ezrah Avenue 19" className="rounded-lg shadow-md" />
          <img src="/ezrah16.jpeg" alt="Ezrah Avenue 20" className="rounded-lg shadow-md" />
          <img src="/ezrah17.jpeg" alt="Ezrah Avenue 21" className="rounded-lg shadow-md" />
          <img src="/ezrah18.jpeg" alt="Ezrah Avenue 22" className="rounded-lg shadow-md" />
          <img src="/ezrah.jpeg" alt="Ezrah Avenue 4" className="rounded-lg shadow-md" />
          <img src="/ezrah1.jpeg" alt="Ezrah Avenue 5" className="rounded-lg shadow-md" />
        </div>
      </div>

      {/* Contact CTA */}
      <div className="bg-indigo-600 text-white text-center py-12">
        <h2 className="text-3xl font-bold mb-4">Interested in Ezrah Avenue?</h2>
        <p className="mb-6">Contact us today to schedule a private tour or request more details.</p>
        <a
          href="/contact"
          className="bg-white text-indigo-600 px-6 py-3 rounded-lg font-semibold shadow hover:bg-gray-100"
        >
          Get in Touch
        </a>
      </div>
    </div>
  );
}
